import EventEmitter from "eventemitter3";
import StoreProps from "../types/Store";
import Store from "./Store";
import Translation from "./Translation";

class StoreBlock {
    EEE: EventEmitter;
    currentStore: StoreProps | null | undefined;
    storeBlocks: NodeListOf<Element>;

    constructor() {
        this.EEE = new EventEmitter();
        this.currentStore = undefined;
        this.storeBlocks = document.querySelectorAll("#store-block");

        this.init();
    }

    // init when store blocks exist
    init() {
        if (this.storeBlocks.length > 0) {
            this.addListeners();
            this.updateStore();
        }
    }

    // Add the store change listeners
    addListeners() {
        this.EEE.on("STORE_CHANGED", (id) => this.updateStore(id));
    }

    // Update the class state
    updateStore(id?: number) {
        if (id && this.currentStore && this.currentStore.id !== id)
            Store.setStore(id);
        this.currentStore = Store.getCurrentStore();
        this.updateBlock();
    }

    findStoreHelpText() {
        return `${this.currentStore?.title ?? Translation.getText("Store","FindStore")} i Google Maps, öppnas i ny flik`;
    }

    // Update the frontend component
    updateBlock() {
        this.storeBlocks.forEach((storeBlock) => {
            if (this.currentStore) {
                const name = storeBlock.querySelector(
                    ".store-block__store-name",
                ) as HTMLElement;
                const openingHours = storeBlock.querySelector(
                    ".store-block__opening-hours",
                ) as HTMLElement;
                const phone = storeBlock.querySelector(
                    ".store-block__phone",
                ) as HTMLElement;
                const addresses = storeBlock.querySelector(
                    ".store-block__addresses",
                ) as HTMLElement;
                const links = storeBlock.querySelector(
                    ".store-block__links",
                ) as HTMLElement;
                const image = storeBlock.querySelector(
                    ".store-block__image-item",
                ) as HTMLElement;

                if (name) name.innerText = this.currentStore.title || "";

                if (openingHours)
                    openingHours.innerText =
                        this.currentStore.opening_hours_large || "";

                if (addresses) {
                    addresses.innerText = "";
                    [
                        this.currentStore.address1,
                        this.currentStore.address2,
                        this.currentStore.address3,
                        this.currentStore.address4,
                    ]
                        .filter(Boolean)
                        .forEach((address) => {
                            addresses.innerHTML += `<p class="store-block__address">${address}</p>`;
                        });
                }

                if (phone)
                    phone.innerHTML =
                        this.currentStore.phone && this.currentStore.phone_url
                            ? `<div><span>Tel. </span><a href="${this.currentStore.phone_url}">${this.currentStore.phone}</a></div>`
                            : "";

                if (links) {
                    links.innerText = "";
                    if (this.currentStore.link) {
                        links.innerHTML += `<a href="${
                            this.currentStore.link
                        }" class="button">${Translation.getText(
                            "Store",
                            "MoreOfStore",
                        )}</a>`;
                    }
                    if (this.currentStore.position) {
                        links.innerHTML += `<a href="${
                            this.currentStore.position.address
                        }" target="_blank" rel="noopener" class="button store-block__external-link"
                        aria-label="${this.findStoreHelpText()}" title="${this.findStoreHelpText()}">${Translation.getText(
                            "Store",
                            "FindStore",
                        )}
                        <i class="fa-solid fa-arrow-up-right-from-square"></i>
                        </a>`;
                    }
                }

                if (image)
                    if (this.currentStore.map_image) {
                        image.classList.remove("is-hidden");
                        image.style.backgroundImage = `url("${this.currentStore.map_image}?preset=large")`;
                    } else {
                        image.style.backgroundImage = "";
                        image.classList.add("is-hidden");
                    }
            }
        });
    }
}

export default StoreBlock;
